import axios, { AxiosRequestConfig } from 'axios';
import config from '.././Config';
import { getHeaders } from './HeaderService';
import { documentDefinition } from '../types/definitions/Document';
import { responseContainer } from '../types/response/ResponseContainer';
import { userActivity, imageState } from '../types/userActivity';
import { PrintImageResponse } from '../types/PrintImageResponse';
import { savedImageResponse } from '../types/Search';
import Common from '../common/Common';

const getImageView = async (
    fileName: string,
    pageIndex: number,
    token: string,
    clientId: string
) => {
    const requestUrl = `${config.searchApi.imageViewGet}/${encodeURIComponent(
        fileName
    )}/${pageIndex}`;
    let image = await axios.request({
        method: 'GET',
        url: requestUrl,
        headers: getHeaders(token, clientId),
    });

    return true;
};

const getImageUrl = async (
    fileName: string,
    pageIndex: number,
    token: string,
    clientId: string
) => {
    const requestUrl = `${config.searchApi.imageUrlGetUrl}/${encodeURIComponent(
        fileName
    )}/${pageIndex}`;
    let image = await axios.request({
        method: 'GET',
        url: requestUrl,
        headers: getHeaders(token, clientId),
    });

    return image;
};

const getFileDetails = async (name: string, token: string, clientId: string) => {
    const requestUrl = `${config.searchApi.fileDetailsGetUrl}/${encodeURIComponent(name)}`;
    let image = await axios.request({
        method: 'GET',
        url: requestUrl,
        headers: getHeaders(token, clientId),
    });

    return image;
};

const getFileDetailsTooltip = async (name: string, token: string, clientId: string) => {
    const requestUrl = `${config.searchApi.fileDetailsTooltipGetUrl}/${encodeURIComponent(name)}`;
    let image = await axios.request({
        method: 'GET',
        url: requestUrl,
        headers: getHeaders(token, clientId),
    });

    return image;
};

const addUniqueAccessDates = (data: documentDefinition[]) => {
    const fileAccessDate = new Date();
    let offset = 0;
    for (let i = data.length - 1; i >= 0; i--) {
        // needed to offset because there is no guarantee that it will get a new time just using new Date()
        var date = new Date(fileAccessDate.getTime() + offset++).toISOString();
        data[i].fileAccessDate = date;
    }
    return data;
};

const printImageRequest = async (
    activity: userActivity,
    token: string,
    fileName: string,
    pages: number[]
) => {
    var response = <responseContainer>{};
    var url = config.searchApi.printImageUrl;

    var axconfig = {
        headers: getHeaders(token, ''),
    };

    const imageState: imageState = {
        FileName: fileName, //.toUpperCase(),
        ImageId: activity.imageName,
        ImageUrl: activity.imageUrl,
        UserId: activity.userName,
        Index: activity.pageIndex,
        ImageOperation: activity.operations,
        State: activity.state,
        County: activity.county,
        PageNumbers: pages.sort((a, b) => a - b),
    };
    var printImageResponse = await axios.post(url, imageState, axconfig);

    response.status = printImageResponse.status;
    response.statusText = printImageResponse.statusText;
    response.output = printImageResponse.data;
    return response;
};

const saveImageRequest = async (
    activity: userActivity,
    token: string,
    fileName: string,
    pages: number[]
) => {
    return new Promise(async (resolve, reject) => {
        var response = <responseContainer>{};
        var url = config.searchApi.saveImageUrl;

        var axconfig = {
            baseURL: config.functionUrl,
            headers: getHeaders(token, ''),
        };

        const imageState: imageState = {
            FileName: fileName, //.toUpperCase(),
            ImageId: activity.imageName,
            ImageUrl: activity.imageUrl,
            UserId: activity.userName,
            Index: activity.pageIndex,
            ImageOperation: activity.operations,
            State: activity.state,
            County: activity.county,
            PageNumbers: pages.sort((a, b) => a - b),
        };

        var saveImageResponse = await axios.post(url, imageState, axconfig);

        response.status = saveImageResponse.status;
        response.statusText = saveImageResponse.statusText;
        response.output = saveImageResponse.data;
        resolve(response);
    });
};

export default {
    getImageUrl,
    getImageView,
    getFileDetails,
    getFileDetailsTooltip,
    addUniqueAccessDates,
    printImageRequest,
    saveImageRequest,
};
